module.exports = __webpack_public_path__ + "static/media/question-mark-2.80858463.svg";